
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';


export const CircleChart = ({score, size, textColor}) => {
  
  const defaultTextColor = '#303030';
  if (!textColor){
    textColor = defaultTextColor
  }


  let  color = '#4CAF50';
  let strokeSize = 5;

  if (size === '100px' || size ==='150px'){
    strokeSize = 10;
  }
  else if (size === '50px') {
    strokeSize = 5;
  }

  if (score>70)
  {
    color = '#4CAF50';
  }
  else if (score>35){
    color = '#FFC107';
  }
  else {
    color = '#F44336';
  }

  return (
    <div style={{ width: size }}>
      <CircularProgressbar
        value={score}
        text={`${score}`}
        strokeWidth={strokeSize}
        styles={{
          path: {
            stroke: color,
            strokeLinecap: 'butt',
          },
          trail: {
            stroke: '#d6d6d6',
          },
          text: {
            fill: textColor,
            fontSize: '24px',
          },
        }}
      />
    </div>
  );
};

/*
export default CircleChart;

import React from "react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

export const CircularProgressBar = ({ percentage, color }) => {
  return (
    <div style={{ width: "50px", height: "50px" }}>
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        styles={{
          // Customize the root svg element
          root: {},
          // Customize the path, i.e. the progress bar
          path: {
            // Path color
            stroke: color,
            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
            strokeLinecap: "round",
            // How thick the progress bar should be
            strokeWidth: "6px",
            // Whether the progress bar should be visible when percentage is 0%
            opacity: percentage === 0 ? 0 : 1
          },
          // Customize the text, i.e. the percentage
          text: {
            // Text color
            fill: color,
            // Font size
            fontSize: "16px",
            // Whether to use bold or normal font weight
            fontWeight: "bold"
          }
        }}
      />
    </div>
  );
};

export default CircularProgressBar;

<style>
.circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: blue;
  position: relative;
}

.percentage {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 16px;
  font-weight: bold;
}
</style>

<div class="circle">
    <div class="percentage">75%</div>
</div>
*/